import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Close";
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridToolbar,
  GridActionsCellItem,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
  GridToolbarDensitySelector,
  useGridApiContext,
  gridExpandedSortedRowIdsSelector,
  GridRowEditStopReasons
} from "@mui/x-data-grid";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SaveAltIcon from '@mui/icons-material/SaveAlt';

import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import getAccess from "../../../utils/getAccess";


function CustomToolbar({ rows, columns }) {
  const apiRef = useGridApiContext();
  const exportAllRows = async () => {
    const visibleRows = gridExpandedSortedRowIdsSelector(apiRef);
    const filteredRows = rows.filter((row) => visibleRows.includes(row.id));
    const columnIds = columns.filter((column) => column.field != 'actions').map((column) => column.field);
    const csvHeader = columnIds.join(', ');
    const csvContent = filteredRows
      .map((row, index) => {
        const rowValues = columnIds.map((columnId) => {
          if (columnId === 'admin') {
            return `${row.admin.name}(${row.admin.role})`;
          }
          else if (columnId === 'parentCategory') {
            return row.parentCategory.title
          }
          else if (columnId === 'serialNumber') {
            return index + 1
          }
          return row[columnId]?.toString()?.replaceAll(",", "");
        });
        return rowValues.join(', ');
      })
      .join('\n');
    const fullCsvContent = `${csvHeader}\n${csvContent}`;
    const blob = new Blob([fullCsvContent], { type: `text/csv;charset=utf-8` });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'StoreCategory.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <GridToolbarFilterButton />

      <GridToolbarDensitySelector />
      <Tooltip title="Export All">
        <IconButton onClick={exportAllRows}>
          <SaveAltIcon style={{ color: 'red' }} />
        </IconButton>
      </Tooltip>
      {/* <GridToolbarQuickFilter /> */}
    </GridToolbarContainer>
  );
};

export default function StoreCategoryTable({
  rows,
  loading,
  rowCount,
  paginationModel,
  setPaginationModel,
  refresh
}) {
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [filterModel, setFilterModel] = React.useState({ items: [] });
  useEffect(() => {
    const handler = (e) => {
      const inFilter = document.activeElement?.closest(".MuiDataGrid-filterForm");

      if (e.key === "Enter" && inFilter) {
        const value = filterModel.items?.[0]?.value || "";
        setPaginationModel(p => ({ ...p, page: 0 }));
        refresh(value);
      }
    };

    document.addEventListener("keydown", handler);
    return () => document.removeEventListener("keydown", handler);
  }, [filterModel]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };
  const access = getAccess();

  const navigate = useNavigate()

  const handleEditClick = (id) => () => {
    navigate(`/dashboard/drag/${id}`)

  };

  const handleSaveClick = (id) => () => {

    setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });
  };

  const handleDeleteClick = (id) => async () => {
    // console.log(id);
    const confirmDelete = window.confirm('Are you sure you want to delete this Product Category?');
    if (confirmDelete) {
      const token = localStorage.getItem('token');
      const res = await fetch(`${process.env.REACT_APP_LIVE_URL}/store/deleteProductCategory/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },

      });
      const resJson = await res.json();
      if (resJson.status) {
        toast.success(resJson.msg);
        refresh();
      }
      else {
        toast.error(resJson.msg);
      }
    };
  }

  const handleCancelClick = (id) => () => {
    setRowModesModel({
      ...rowModesModel,
      [id]: { mode: GridRowModes.View, ignoreModifications: true }
    });
  };
  const processRowUpdate = (row) => row;


  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };
  const rowsWithSerialNumber = rows?.map((row, index) => ({ ...row, serialNumber: index + 1 }));
  const columns = [
    {
      field: 'serialNumber',
      headerName: 'S NO',
      width: 75,
      align: 'left',
      headerAlign: 'left',
      editable: false,
      renderCell: (params) => (
        <strong>{params.value}</strong>
      ),
    },
    {
      field: "id",
      headerName: "Id",
      type: "string",
      width: 220,
      align: "left",
      headerAlign: "left",
      // editable: true
    },

    {
      field: "title",
      headerName: "Title",
      type: "string",
      width: 150,
      align: "left",
      headerAlign: "left",
      editable: true
    },
    {
      field: "admin",
      headerName: "Created By",
      type: "string",
      width: 200,
      align: "left",
      headerAlign: "left",
      // editable: true
      renderCell: (params) => {
        return (
          <div>{`${params.value.name} (${params.value.role})`}</div>
        )
      }
    },
    {
      field: "url",
      headerName: "Url",
      type: "string",
      width: 200,
      align: 'left',
      headerAlign: "left",
      // editable : true
      renderCell: (params) => (
        <a href={params.value || "#"} target="_blank" rel="noreferrer">Link</a>
      ),
    },
    {
      field: "icon",
      headerName: "Image",
      type: "file",
      width: 200,
      align: "left",
      headerAlign: "left",
      editable: true,
      renderCell: (params) => {


        return (params?.value != "" ? <img
          src={params.value}
          alt={`Image for row ${params.id}`}
          style={{ width: 150, height: 70 }}
        /> : <strong>{"NA"}</strong>)

      },
    },
    {
      field: "order",
      headerName: "Order",
      type: "object",
      width: 70,
      align: "left",
      headerAlign: "left",

    },
    {
      field: "parentCategory",
      headerName: "Parent Category",
      type: "object",
      width: 150,
      align: "left",
      headerAlign: "left",
      editable: true,
      renderCell: (params) => (
        <div>{params.value.title ? params.value.title : "NA"}</div>
      ),
    },
    {
      field: "isActive",
      headerName: "Status",
      type: "boolean",
      width: 100,
      align: "left",
      headerAlign: "left",
      editable: true,
      renderCell: (params) => (
        <div style={{ color: params.value === true ? 'green' : 'red' }}>
          {params.value ? 'Active' : 'inActive'}
        </div>
      ),
    },
    {
      field: "createdAt",
      headerName: "Created At",
      type: "Date",
      width: 150,
      align: "left",
      headerAlign: "left",
      editable: true,
      renderCell: (params) => {
        // console.log('value', params)
        return <div>{params.value}</div>
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: ({ id }) => {
        const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

        if (isInEditMode) {
          return [
            <GridActionsCellItem
              icon={<SaveIcon />}
              label="Save"
              sx={{
                color: "primary.main"
              }}
              onClick={handleSaveClick(id)}
            />,
            <GridActionsCellItem
              icon={<CancelIcon />}
              label="Cancel"
              className="textPrimary"
              onClick={handleCancelClick(id)}
              color="inherit"
            />
          ];
        }

        return [
          ((access?.accessForTab == 'readWrite' || access?.access.includes('all')) ? <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          /> : <></>),
          ((access?.deleteAccess || access?.access.includes('all')) ? <GridActionsCellItem
            icon={<DeleteIcon style={{ color: 'red' }} />}
            label="Delete"
            onClick={handleDeleteClick(id)}
            color="inherit"
          /> : <></>)
        ];
      }
    }
  ]



  return (
    <Box
      sx={{
        height: 590,
        width: "100%",
        "& .actions": {
          color: "text.secondary"
        },
        "& .textPrimary": {
          color: "text.primary"
        }
      }}
    >
      <DataGrid
        getRowHeight={() => 'auto'}
        rows={rowsWithSerialNumber}
        columns={columns}

        paginationMode="server"
        rowCount={rowCount}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        loading={loading}

        filterModel={filterModel}
        onFilterModelChange={(model) => setFilterModel(model)}

        editMode="row"
        rowModesModel={rowModesModel}
        onRowModesModelChange={handleRowModesModelChange}
        onRowEditStop={handleRowEditStop}
        processRowUpdate={(row) => row}

        pageSizeOptions={[7, 25, 50]}

        slots={{
          toolbar: (gridProps) => (
            <CustomToolbar {...gridProps} rows={rows} columns={columns} />
          ),
        }}

        slotProps={{
          toolbar: { setRowModesModel }
        }}
      />
      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </Box>
  );
}
